import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9be02a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "robot_record" }
const _hoisted_2 = { class: "record_head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head_name" }, "机器人使用记录", -1))
const _hoisted_4 = { class: "record_list" }
const _hoisted_5 = ["src"]

import { message, notification, Table } from 'ant-design-vue';
import http from '@/api';
import router from '@/router';
import { getCurrentInstance, ref } from 'vue';
import { getToken } from '@/plugins/cookie';
import { useConsoleStore } from '@/pinia/console';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';
import { useDebounce } from '@/hooks/useDebounce'; //防抖

interface DataItem {
  id: number;
  avatar_url: string;
  name: string;
  time: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RobotRecord',
  emits: ['update:onHideList'],
  setup(__props, { emit }) {


const aTable = Table;

const studioId = router.currentRoute.value.params.studioId;
const columns = [
  {
    title: '头像',
    dataIndex: 'avatar_url',
    slots: { customRender: 'url' },
  },
  {
    title: '昵称',
    dataIndex: 'name',
    ellipsis: true,
  },
  {
    title: '使用时间',
    dataIndex: 'time',
    width: '40%',
    align: 'left',
  },
];
const postes = ref<DataItem[]>([]);
const getData = () => {
  const data = {
    studio_id: studioId,
    export: 0,
  };
  http.liveExpress.robotList({ params: data }).then((res) => {
    postes.value = res.data.data;
  });
};
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const { proxy }: any = getCurrentInstance();
const exportList = useDebounce(() => {
  const data = {
    studio_id: studioId,
    export: 1,
    is_cron_download: corn.value,
  };
  https.robot_list({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
getData();
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });

};

const consoleStore = useConsoleStore();
const updateRobot = (record: any) => {
  consoleStore.robotInfo = {
    avatar_id: record.avatar_id,
    avatar_url: record.avatar_url,
    name: record.name,
    id: record.robot_id,
    lock: record.lock,
  };
};

const exitCustomRow = (record: any, index: number) => {
  return {
    onClick: () => {
      updateRobot(record);
      emit('update:onHideList');
    },
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "head_ecport",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exportList)()))
      }, "导出 >>")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(aTable), {
        columns: columns,
        "data-source": postes.value,
        pagination: false,
        scroll: { y: 280 },
        "row-key": "id",
        customRow: exitCustomRow
      }, {
        url: _withCtx(({ record }) => [
          _createElementVNode("img", {
            src: record.avatar_url,
            class: "img_w"
          }, null, 8, _hoisted_5)
        ]),
        _: 1
      }, 8, ["data-source"])
    ])
  ]))
}
}

})